import { useUserContext } from '../user/context/UserContext.tsx';

interface AuthState {
  isAuthenticated: boolean;
  isAdmin: boolean;
  isLoading: boolean;
  user: any | null;
}

export const useAuthGuard = (): AuthState => {
  const { userInfo } = useUserContext();

  return {
    isAuthenticated: !!userInfo,
    isAdmin: userInfo?.user?.isAdmin || false,
    isLoading: false,
    user: userInfo?.user || null,
  };
};
